import axios from "axios";
import { Constants } from '../utils/Constants';

export function create(form) {
	return axios.post(`${Constants.baseUrl}/dom-pagamentos/conta`, form);
}